import { createReduxConstants } from '@bibliocommons/utils-redux';

export const FILTER_SEPARATOR = ',';
export const EVENTS_FACET_FIELDS = {
  ADJACENT_LOCATIONS: 'adjacentLocations',
  BRANCH_LOCATIONS: 'locations',
  EVENT_TYPES: 'types',
  EVENT_PROGRAMS: 'programs',
  EVENT_AUDIENCES: 'audiences',
  EVENT_LANGUAGES: 'languages'
};

export const FACET_FIELDS_ORDER = [
  EVENTS_FACET_FIELDS.ADJACENT_LOCATIONS,
  EVENTS_FACET_FIELDS.BRANCH_LOCATIONS,
  EVENTS_FACET_FIELDS.EVENT_TYPES,
  EVENTS_FACET_FIELDS.EVENT_PROGRAMS,
  EVENTS_FACET_FIELDS.EVENT_AUDIENCES,
  EVENTS_FACET_FIELDS.EVENT_LANGUAGES
];

export default createReduxConstants('EVENTS', {
  SEARCH_EVENTS_REQUEST: null,
  SEARCH_EVENTS_SUCCESS: null,
  SEARCH_EVENTS_FAILURE: null,
  FETCH_FEATURED_EVENTS_REQUEST: null,
  FETCH_FEATURED_EVENTS_SUCCESS: null,
  FETCH_FEATURED_EVENTS_FAILURE: null
});
